(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('prem-disc-group', {
            // parent: 'entity',
            parent: 'app',
            url: '/prem-disc-group?page&sort&search',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.premDiscGroup.home.title',
                title: 'Perm Disc Group'
            },
            views: {
                // 'content@': {
                'prem-disc-group@': {
                    templateUrl: 'app/entities/prem-disc-group/prem-disc-groups.html',
                    controller: 'PremDiscGroupController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('premDiscGroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('prem-disc-group-detail', {
            // parent: 'entity',
            parent: 'app',
            url: '/prem-disc-group/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.premDiscGroup.detail.title',
                title: 'Detail'
            },
            views: {
                // 'content@': {
                'prem-disc-group-detail@': {
                    templateUrl: 'app/entities/prem-disc-group/prem-disc-group-detail.html',
                    controller: 'PremDiscGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('premDiscGroup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PremDiscGroup', function($stateParams, PremDiscGroup) {
                    return PremDiscGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'prem-disc-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('prem-disc-group-detail.edit', {
            // parent: 'prem-disc-group-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/prem-disc-group/detail/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prem-disc-group/prem-disc-group-dialog.html',
                    controller: 'PremDiscGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PremDiscGroup', function(PremDiscGroup) {
                            return PremDiscGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('prem-disc-group.new', {
            // parent: 'prem-disc-group',
            parent: 'app',
            // url: '/new',
            url: '/prem-disc-group/new',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prem-disc-group/prem-disc-group-dialog.html',
                    controller: 'PremDiscGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdOn: null,
                                createdBy: null,
                                modifiedOn: null,
                                modifiedBy: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('prem-disc-group', null, { reload: true });
                }, function() {
                    $state.go('prem-disc-group');
                });
            }]
        })
        .state('prem-disc-group.edit', {
            // parent: 'prem-disc-group',
            parent: 'app',
            // url: '/{id}/edit',
            url: '/prem-disc-group/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prem-disc-group/prem-disc-group-dialog.html',
                    controller: 'PremDiscGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PremDiscGroup', function(PremDiscGroup) {
                            return PremDiscGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('prem-disc-group', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('prem-disc-group.delete', {
            // parent: 'prem-disc-group',
            parent: 'app',
            // url: '/{id}/delete',
            url: '/prem-disc-group/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prem-disc-group/prem-disc-group-delete-dialog.html',
                    controller: 'PremDiscGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PremDiscGroup', function(PremDiscGroup) {
                            return PremDiscGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('prem-disc-group', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );
        
    }

})();
